import React from "react";
import styled from "styled-components";
import {kpiBackgroundColour} from "../../../../style/styleConsts";

export const ItemContainer = styled.div`
    padding: 5px 5px;
`;

export const RankContainer = styled(ItemContainer)`
    width: 32px;
    flex-grow: 0;
    flex-shrink: 0;
`;

export const NameContainer = styled(ItemContainer)`
    width: 150px;
    flex-grow: 2;
    flex-shrink: 0;
`;

export const NewIdeasContainer = styled(ItemContainer)`
    width: 66px;
    flex-grow: 0;
    flex-shrink: 0;
`;

export const StatContainer = styled(ItemContainer)`
    width: 95px;
    flex-grow: 1;
    flex-shrink: 0;
    background-color: ${props => props.showKpiBackgroundColour ? kpiBackgroundColour : "inherit"};
`;